import { useEffect } from 'react'
import mousetrap from 'mousetrap'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'dependencies' implicitly has an 'any' t... Remove this comment to see the full error message
export default function (config = [], dependencies) {
  useEffect(() => {
    config.forEach(({ keys, handler }) => {
      mousetrap.bind(keys, handler, 'keyup')
    })

    return () => {
      config.forEach(({ keys, handler }) => {
        // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 3.
        mousetrap.unbind(keys, handler, 'keyup')
      })
    }
  }, dependencies)
}
